module.exports = __webpack_public_path__ + "static/media/no-image.5f09172c.jpeg";